<script setup>
import { onBeforeUnmount, ref } from "vue";
import { useGlobalStore } from "@stores/global";
import { useExpediaStore } from "@stores/expedia";
import { useRouter } from "vue-router";
import IconArrowUpRight from "@components/icons/ArrowUpRight.vue";
import Button from "@components/Button.vue";

const router = useRouter();
const globalStore = useGlobalStore();
const expediaStore = useExpediaStore();
const agreed = ref(false);

onBeforeUnmount(() => {
    if (router.currentRoute.value.name === "help") {
        router.push({ name: "explore" });
    }
});

async function openRules(lang) {
    await router.push({ name: "rules", params: { lang } });
    globalStore.closeModal();
}

function trackMeetSpeed() {
    if (typeof window.gtag === "function") {
        window.gtag("event", "clicked_meet_speed");
    }
}
</script>

<template>
    <div class="flex w-full max-w-2xl items-center gap-3">
        <div
            class="hidden h-full w-60 shrink-0 items-center justify-center md:flex"
        >
            <img
                src="https://speed-cdn.expedia.com/images/elements/meet-speed.jpg"
                class="rounded-2xl"
                alt=""
            />
        </div>

        <div
            class="flex h-full flex-1 flex-col justify-between gap-12 overflow-y-auto p-2 pb-6 md:px-6"
        >
            <div class="flex flex-col gap-4 pt-6">
                <p class="h5 leading-[0.9] font-bold tracking-tight uppercase">
                    Meet Speed
                </p>
                <div
                    class="body-sm faded-text flex flex-col gap-4 leading-[1.4]"
                >
                    <p>
                        Wanna link up with Speed off-stream for real? Book any
                        trip on this site for your shot to meet him
                        face-to-face. Where will you go? A quick weekend getaway
                        to New York City? A bucket-list Tokyo run? Or chasing
                        his past streams around the map?
                    </p>
                    <p>
                        The prize: a trip worthy of Speed to meet the legend
                        himself. Roundtrip airfare, accommodation and spending
                        money for a once in a lifetime meet and greet with
                        IShowSpeed.
                    </p>
                    <p>
                        NO PURCHASE NECESSARY. Legal residents of the US, Canada
                        (including Quebec) and Mexico at least 18+ years old.
                        Ends 9/07/26. To enter and for Official Rules, including
                        odds, and prize descriptions visit
                        <button
                            class="text-white underline"
                            @click="openRules('en')"
                        >
                            Official Rules (EN)</button
                        >,
                        <button
                            class="text-white underline"
                            @click="openRules('es')"
                        >
                            Reglas Oficiales (ES)</button
                        >,
                        <button
                            class="text-white underline"
                            @click="openRules('fr')"
                        >
                            Règlement Officiel (FR)</button
                        >. Void where prohibited. Sponsor: Expedia, Inc.
                    </p>
                </div>
            </div>

            <div class="flex flex-col gap-8">
                <Button
                    :href="expediaStore.href('')"
                    target="_blank"
                    :disabled="!agreed"
                    className="justify-between! px-4! w-full!"
                    @click="trackMeetSpeed"
                >
                    <span>Book a trip on Expedia</span>
                    <div
                        class="bg-marine-600 flex size-8 items-center justify-center rounded-md text-yellow-400"
                    >
                        <IconArrowUpRight class="size-5" />
                    </div>
                </Button>

                <label class="flex items-center gap-2">
                    <button
                        :class="[
                            'border-marine-500 bg-marine-800 flex size-5 shrink-0 items-center justify-center overflow-clip border',
                            agreed && 'border-yellow-400 bg-yellow-400',
                        ]"
                        @click.prevent="agreed = !agreed"
                    >
                        <svg
                            v-if="agreed"
                            width="12"
                            height="12"
                            viewBox="0 0 20 20"
                            fill="none"
                            class="text-marine-800"
                        >
                            <path
                                d="M16.6668 5L7.50016 14.1667L3.3335 10"
                                stroke="currentColor"
                                stroke-width="3"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                    <span class="body-sm faded-text leading-[1.4]">
                        I read and agree to Sweepstakes Rules above.
                    </span>
                </label>
            </div>
        </div>
    </div>
</template>
